import { Component, EventEmitter, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { USER_TYPES } from '../../constants';

@Component({
  selector: 'app-toggle-switch',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toggle-container" (click)="toggle()">
      <div class="toggle-background">
        <div class="toggle-indicator" [class.active]="activo()"></div>
        <div class="toggle-labels">
          <span [class.selected]="!activo()">Mentores</span>
          <span [class.selected]="activo()">Expertos</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .toggle-container {
      width: 320px;
      cursor: pointer;
      user-select: none;
    }

    .toggle-background {
      position: relative;
      // background-color: #fff;
      border-radius: 999px;
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      border: 1px solid #CE0024;
      box-shadow: inset 0 0 4px rgba(0,0,0,0.1);
    }

    .toggle-indicator {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      width: 150px;
      background-color: #CE0024;
      border-radius: 999px;
      transition: left 0.3s ease;
      box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    }

    .toggle-indicator.active {
      left: calc(100% - 150px);
    }

    .toggle-labels {
      width: 100%;
      display: flex;
      justify-content: space-between;
      z-index: 1;
      padding: 0 12px;
      font-weight: 500;
      font-size: 28px;
    }

    .toggle-labels span {
      color: #000;
      transition: color 0.3s ease;
    }

    .toggle-labels .selected {
      color: #fff;
    }

    @media (max-width: 768px) {
      .toggle-container {
        width: 90%;
      }

      .toggle-labels {
        font-size: 22px;
      }
    }
  `]
})
export class ToggleSwitchComponent {
  activo = signal(false);
  @Output() changeEvent = new EventEmitter<number>();

  toggle() {
    this.activo.update(v => !v);
    this.changeEvent.emit(this.activo() ? USER_TYPES.Expert.id : USER_TYPES.Coach.id);
  }
}
